/* tslint:disable:no-shadowed-variable */

import { environment as dev } from '../../../environments/environment.dev';
import { environmentPROD as prod } from '../../../environments/environment.prod';
import { environmentQA as qa } from '../../../environments/environment.qa';
import { environmentLocal as local } from '../../../environments/environment.local';
import { Inject, Injectable, InjectionToken } from '@angular/core';

declare let window: any;

export const environments = {
  default: local,
  dev: dev,
  prod: prod,
  qa: qa
};

export interface EnvironmentConfigurationSettings {
  [setting: string]: any;
}

export interface EnvironmentConfigurations {
  default: EnvironmentConfigurationSettings;
  [environment: string]: EnvironmentConfigurationSettings;
}

export const Environments = new InjectionToken<EnvironmentConfigurations>('Environments');

@Injectable()
export class EnvironmentConfiguration implements EnvironmentConfigurationSettings {
  [setting: string]: any;

  constructor(@Inject(Environments) environments: EnvironmentConfigurations) {
	const originUrl = window.location.href;
    if (originUrl.includes('event-view-details/')){
      sessionStorage.setItem("landingPage",'eventDetails');
      const id = originUrl.split('/').pop();
      localStorage.setItem('eventId',id);
    }  
    else if(originUrl.includes('take-survey/')){
      sessionStorage.setItem("landingPage",'takeSurvey');
      const id = originUrl.split('/').pop();
      localStorage.setItem('surveyId',id);
    }
    else if(originUrl.includes('membership/site')){
      sessionStorage.setItem("landingPage",'membershipSite');
    }
   
    const hostname1 = (window.location && window.location.hostname) ? window.location.hostname.toLowerCase() : null;
    const hostname = hostname1.replace('www.','');
    let environmentType = environments.default;

    const environmentNames: string[] = Object.keys(environments).filter(envName => envName !== 'default');
    let selectedEnvName = environmentNames.find(envName => {
      if (environments[envName] && environments[envName].hostname) {
        const envHostname = environments[envName].hostname;
        if (Array.isArray(envHostname)) {
          return envHostname.some(h => h.toLowerCase() === hostname);
        }
        return envHostname.toLowerCase() === hostname;
      } else {
        return false;
      }
    });


    // Override default behavior by setting window.environment in index.html
    if (window['environment'] && environments[window['environment']]) {
      selectedEnvName = window['environment'];
    }

    if (!selectedEnvName) {
      selectedEnvName = 'default';
    } else if (selectedEnvName && environments[selectedEnvName]) {
      environmentType = environments[selectedEnvName];
    }

    environmentType.envName = selectedEnvName;

    Object.assign(this, environmentType);
  }
}
